import { lazy } from "react";

export const LeaveSummaryReports = lazy(() => import("./leave/LeaveSummary/LeaveSummary"))
export const LeaveDetailsReports = lazy(() => import("./leave/leaveDetailsReports/LeaveDetailsReports"))
export const LeaveEmployeeWiseReports = lazy(() => import("./leave/LeaveEmployeeWise/LeaveEmployeeWise"))
export const OTDetailsReports = lazy(() => import("./OT/otDetailsReports/OTDetailsReports"))
export const OTProjectReports = lazy(() => import("./OT/otProjectReports/OTProjectReports"))
export const OTSummaryReports = lazy(() => import("./OT/otSummaryReports/OTSummaryReports"))
export const InactiveEmployees = lazy(() => import("./inactiveEmployees/InactiveEmployee"))
export const InternshipCandidatesReports = lazy(() => import("./internship/InternshipReports"))
export const AttendanceReports= lazy(() => import("./attendance/AttendanceReports"))